let Env = ''
switch (location.hostname) {
  case 'localhost':
    Env = 'test'
    break
  case 'live-wbs310.newtamp.cn':
    Env = 'test'
    break
  case 'live-ysc.harvestwm.cn': // 预生产
    Env = 'product'
    break
  case 'https://m.harvestwm.cn': // :生产
    Env = 'product'
    break
  default:
    Env = 'dev'
}
export default Env
